import React from "react";
import { Route } from "react-router-dom";
import type { RouteCtx } from "../routeContext";
import { RoleDashboard } from "../shell";
import { TenantDashboard, SiteDashboard, StudyMilestones } from "../lazyPages";

/** dashboardShellRoutes — order preserved for React Router first-match. */
export function dashboardShellRoutes(ctx: RouteCtx): React.ReactNode {
  const {
    selectedStudyId,
    availableStudies,
    currentStudy,
    user,
    onLogout,
    userStudyRoles,
  } = ctx;

  return (
    <>
      {/* ── 1. Dashboard shell (all authenticated roles) ───────────────── */}
      <Route
        path="/dashboard"
        element={
          <RoleDashboard
            user={user}
            onLogout={onLogout}
            selectedStudyId={selectedStudyId}
            userStudyRoles={userStudyRoles}
            availableStudies={availableStudies}
          />
        }
      />
      {/* Dashboard sub routes matching Tenant Admin UI */}
      <Route path="/dashboard/tenant" element={<TenantDashboard />} />
      <Route path="/dashboard/study" element={<StudyMilestones />} />
      <Route
        path="/dashboard/site"
        element={<SiteDashboard currentStudy={currentStudy} />}
      />
    </>
  );
}
